<template>
  <div>
    <div class="container-fluid bg-light py-6 mt-0">
      <div class="container text-center animated bounceInDown">
        <h1 class="display-1 mb-4">{{ $t("aboutSchool") }}</h1>
        <ol
          class="breadcrumb justify-content-center mb-0 animated bounceInDown"
        >
          <li class="breadcrumb-item"><a href="#">{{ $t("home") }}</a></li>
          <li class="breadcrumb-item"><a href="#">{{ $t("aboutSchool") }}</a></li>
          <li class="breadcrumb-item text-dark" aria-current="page">
            {{  $t('greetingOfPrinciple') }}
          </li>
        </ol>
      </div>
    </div>
    <div class="container">
      <div class="row g-5 mt-3 p-1">
        <div class="col-lg-4 wow bounceInUp" data-wow-delay="0.1s">
            <img src="img/principle.jpg" class="img-fluid rounded" alt="" />
        </div>
        <div class="col-lg-8 wow bounceInUp" data-wow-delay="0.3s">
          <small
            class="d-inline-block fw-bold text-dark text-uppercase bg-light border border-primary rounded-pill px-4 py-1 mb-3"
            >{{  $t('greetingOfPrinciple') }}</small
          >
          <h1 class="display-5 mb-4">{{ $t('greetingTitle') }}</h1>
          <p class="mb-4">
            {{ $t('greetingPara') }}
          </p>
          <p v-html="$t('greetingInfo')">
            
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
